// frontend/src/components/CookieConsent/consentTexts.js

export const getConsentTexts = (isHebrew) => ({
  title: isHebrew ? 'הגדרות עוגיות' : 'Cookie Settings',

  description: isHebrew
    ? 'אנו משתמשים בעוגיות כדי שהאתר יפעל כראוי ולשיפור החוויה שלך. ניתן לבחור אילו עוגיות לאפשר, ולשנות זאת בכל עת.'
    : 'We use cookies to keep the site working properly and to improve your experience. Choose which cookies to allow - you can change this at any time.',

  privacyPolicy: isHebrew ? 'מדיניות הפרטיות' : 'Privacy Policy',

  categories: {
    necessary: {
      title: isHebrew ? 'עוגיות חיוניות' : 'Necessary Cookies',
      description: isHebrew
        ? 'נדרשות לפעולה התקינה של האתר, כולל התחברות, אבטחה ושמירת ההעדפות שלך. לא ניתן לכבות אותן.'
        : 'Required for the site to work properly, including sign-in, security, and remembering your preferences. These cannot be turned off.',
    },
    analytics: {
      title: isHebrew ? 'עוגיות אנליטיקה' : 'Analytics Cookies',
      description: isHebrew
        ? 'עוזרות לנו להבין כיצד משתמשים באתר כדי לשפר אותו, לצרכים סטטיסטיים.'
        : 'Help us understand how the site is used so we can improve it, for statistical purposes.',
    },
    marketing: {
      title: isHebrew ? 'עוגיות שיווק' : 'Marketing Cookies',
      description: isHebrew
        ? 'מאפשרות לנו ולפלטפורמות פרסום, כגון Meta, למדוד את יעילות הפרסום שלנו ולהציג מודעות מותאמות.'
        : 'Allow us and advertising platforms, such as Meta, to measure the effectiveness of our advertising and to show tailored ads.',
    },
  },

  buttons: {
    acceptAll: isHebrew ? 'קבל הכל' : 'Accept All',
    acceptSelected: isHebrew ? 'שמור העדפות' : 'Save Preferences',
    rejectAll: isHebrew ? 'דחה הכל' : 'Reject All',
    close: isHebrew ? 'סגור' : 'Close',
  },

  banner: {
    description: isHebrew
      ? 'אנו משתמשים בעוגיות לתפעול האתר, לניתוח השימוש בו ולפרסום.'
      : 'We use cookies to operate the site, to analyze how it is used and for advertising.',
    acceptAll: isHebrew ? 'אישור' : 'Accept',
    rejectNonEssential: isHebrew ? 'חיוניות בלבד' : 'Essential only',
    managePreferences: isHebrew ? 'הגדרות' : 'Settings',
  },

  status: {
    alwaysEnabled: isHebrew ? 'תמיד פעיל' : 'Always Active',
  },

  messages: {
    saved: isHebrew ? 'ההעדפות שלך נשמרו' : 'Your preferences have been saved',
    updated: isHebrew ? 'הגדרות העוגיות עודכנו' : 'Cookie settings have been updated',
  },
});
